/* Site-wide ex-VAT / inc-VAT price display toggle.
   Assumes a flat 20% UK VAT rate is already baked into every displayed price.
   Elements opt in by carrying data-price-cents (the inc-VAT amount, in pence);
   this only ever rewrites displayed text - it never touches cart/checkout math,
   which always continues to use the real inc-VAT price Shopify charges.

   The switch defaults to "on" = showing inc-VAT prices, matching the label
   convention: pressed/on means inc. VAT, unpressed/off means ex. VAT. */
window.SpeedyVat = (function () {
  var PREF_KEY = 'sr_vat_pref';
  var VAT_RATE = 1.2;

  function getPref() {
    try {
      return localStorage.getItem(PREF_KEY) === 'ex' ? 'ex' : 'inc';
    } catch (e) {
      return 'inc';
    }
  }

  function setPref(pref) {
    try {
      localStorage.setItem(PREF_KEY, pref);
    } catch (e) {}
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
    });
  }

  function applyToElement(el) {
    var incCents = parseInt(el.getAttribute('data-price-cents'), 10);
    if (isNaN(incCents)) return;
    var pref = getPref();
    var displayCents = pref === 'ex' ? Math.round(incCents / VAT_RATE) : incCents;
    var formatted = formatMoney(displayCents);
    if (el.textContent !== formatted) {
      el.textContent = formatted;
    }
  }

  /* Same idea as applyToElement, but for "X.Xp per page" style figures,
     which aren't money-formatted amounts (no currency symbol/decimals via
     formatMoney) so they carry their own data attribute: the inc-VAT pence
     value as a plain number, e.g. data-pence-per-unit="2.2". */
  function applyPenceElement(el) {
    var incPence = parseFloat(el.getAttribute('data-pence-per-unit'));
    if (isNaN(incPence)) return;
    var pref = getPref();
    var displayPence = pref === 'ex' ? Math.round((incPence / VAT_RATE) * 10) / 10 : incPence;
    var formatted = displayPence + 'p';
    if (el.textContent !== formatted) {
      el.textContent = formatted;
    }
  }

  function applyAll() {
    var pref = getPref();
    document.querySelectorAll('[data-price-cents]').forEach(applyToElement);
    document.querySelectorAll('[data-pence-per-unit]').forEach(applyPenceElement);
    document.querySelectorAll('[data-vat-suffix]').forEach(function (el) {
      var text = pref === 'ex' ? 'ex VAT' : 'inc VAT';
      if (el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('[data-vat-toggle-label]').forEach(function (el) {
      var text = pref === 'ex' ? 'Show prices ex. VAT' : 'Show prices inc. VAT';
      if (el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('[data-vat-toggle-switch]').forEach(function (el) {
      el.setAttribute('aria-pressed', pref === 'inc' ? 'true' : 'false');
    });
  }

  function injectStyles() {
    if (document.getElementById('SrVatStyles')) return;
    var style = document.createElement('style');
    style.id = 'SrVatStyles';
    style.textContent =
      '.price-vat-suffix { font-size: 1em !important; font-weight: 500 !important; color: rgba(var(--color-foreground), 0.7) !important; margin-left: 0.4rem !important; white-space: nowrap !important; }' +
      '.price--large .price-vat-suffix { font-size: 1.8rem !important; margin-left: 0.8rem !important; }';
    document.head.appendChild(style);
  }

  function toggle(pref) {
    setPref(pref);
    applyAll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectStyles();
    applyAll();

    document.querySelectorAll('[data-vat-toggle-switch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggle(getPref() === 'ex' ? 'inc' : 'ex');
      });
    });

    var observer = new MutationObserver(function (mutations) {
      var shouldApply = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          shouldApply = true;
          break;
        }
      }
      if (shouldApply) applyAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  return { getPref: getPref, toggle: toggle, applyAll: applyAll };
})();
